<p-blockUI [blocked]="blockUiService.isBlocked$ | async">
  <div class="block-ui-wrapper block-ui-main" style="height: 100%">
    <div class="loader"></div>
  </div>
</p-blockUI>

<div
  class="layout-container h-full"
  [ngClass]="{
    'layout-slim': this.ixNgMenuService.slimMenu,
    'layout-overlay': this.ixNgMenuService.overlayMenu,
    'layout-static': this.ixNgMenuService.staticMenu,
    'layout-static-inactive': this.ixNgMenuService.staticMenuInactive,
    'layout-overlay-active': this.ixNgMenuService.overlayMenuActive,
    'layout-mobile-active': this.ixNgMenuService.mobileMenuActive,
    'layout-topbar-menu-active': this.layoutService.layoutTopbarMenuActive,
  }"
>
  <app-topbar #appTopBar [admin]="false"></app-topbar>

  <main class="layout-content-wrapper flex flex-column min-h-full">
    <p-toast />
    @if (ixNgConfirmationService.appIxConfirmationOpen) {
      <ix-confirmation></ix-confirmation>
    }
    @if (this.ixNgComValidationService.appComValidationOpen) {
      <lib-validation-dialog></lib-validation-dialog>
    }
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
    <lib-footer class="layout-footer"></lib-footer>
  </main>

  @if (this.ixNgMenuService.mobileMenuActive) {
    <div class="layout-mask"></div>
  }
</div>

<p-confirmDialog
  icon="fa fa-question-circle"
  acceptLabel="Nadaljuj brez shranjevanja"
  rejectLabel="Ostani na strani"
></p-confirmDialog>
